module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/inline-style-prefixer/static.js
// module id = 273
// module chunks = 0